'use strict';

import queryString from 'query-string';

/**
 * URL handling and pricing for the v2 credit limit (luottolimiitti) form.
 *   /avaa-luottolimiitti/loanamount=30000
 *   /avaa-luottolimiitti/?loanamount=30000
 * loanamount present → "prefilled" mode (collapsed summary with an edit link).
 *
 * The live limit form only lets the user pick the limit amount; loan length (12) and
 * capital-free months (0) are fixed and sent as-is, and the shown cost is the monthly
 * interest instalment of 2 % on a fully used limit.
 */

export const LIMIT = { min: 2000, max: 50000, step: 1000, default: 20000 };
export const FIXED_LOAN_LENGTH = 12;
export const FIXED_FREE_MONTHS = 0;
export const MONTHLY_RATE = 0.02;

const clamp = (n, { min, max }) => Math.min(max, Math.max(min, n));
const snap = (n, { step }) => Math.round(n / step) * step;

export function parseLimitParams(match, search) {
  const pathParams = queryString.parse((match && match.params && match.params.id) || '');
  const query = queryString.parse(search || '');
  const values = { ...query, ...pathParams };

  const amount = parseInt(values.loanamount, 10);
  const prefilled = !isNaN(amount);

  return {
    values,
    mode: prefilled ? 'prefilled' : 'open',
    limit: prefilled ? snap(clamp(amount, LIMIT), LIMIT) : LIMIT.default,
  };
}

export const monthlyInterest = (limit) => Math.round(limit * MONTHLY_RATE);
